import React from 'react';
import { Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';

import BookingUtils from 'utils/bookings';

import './style.css';

const { getColorByStatus } = BookingUtils;

const formatDate = (date) => {
  return moment.utc(date).format('DD/MM/YY');
};
const formatTime = (date) => {
  return moment.utc(date).format('HH:mm');
};

const BookingsTable = ({ bookings, userKey, profile, actions }) => {
  const statusFilter = bookings.reduce((acc, value) => {
    const o = {
      text: value.status,
      value: value.status,
    };

    if (!acc.find((i) => i.value === value.status)) {
      acc.push(o);
    }
    return acc;
  }, []);

  const userFilter = bookings.reduce((acc, value) => {
    const { firstName, lastName, [userKey]: userId } = value;
    const o = {
      text: `${firstName} ${lastName}`,
      value: userId,
    };
    if (!acc.find((i) => i.value === userId)) {
      acc.push(o);
    }
    return acc;
  }, []);

  const columns = [
    {
      title: 'User',
      dataIndex: 'firstName',
      rowKey: userKey,
      sorter: (a, b) => {
        return (
          `${a.firstName} ${a.lastName}`.length -
          `${b.firstName} ${b.lastName}`.length
        );
      },
      render: (text, record) => (
        <Link to={`${profile}${record[userKey]}`}>
          {text} {record.lastName}
        </Link>
      ),
      filters: userFilter,
      onFilter: (value, record) => record[userKey] === value,
    },
    {
      title: 'Start',
      dataIndex: 'dateStart',
      rowKey: 'dateStart',
      render: (text) => <span>{formatDate(text)}</span>,
      sorter: (a, b) => moment.utc(a.dateStart) - moment.utc(b.dateStart),
    },
    {
      title: 'End',
      dataIndex: 'dateEnd',
      rowKey: 'dateEnd',
      render: (text) => <span>{formatDate(text)}</span>,
      sorter: (a, b) => moment.utc(a.dateEnd) - moment.utc(b.dateEnd),
    },
    {
      title: 'Shift Start',
      dataIndex: 'dateStart',
      rowKey: 'shiftStart',
      render: (text) => <span>{formatTime(text)}</span>,
      sorter: null,
    },
    {
      title: 'Shift End',
      dataIndex: 'dateEnd',
      rowKey: 'shiftEnd',
      render: (text) => <span>{formatTime(text)}</span>,
      sorter: null,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      rowKey: 'status',
      sorter: (a, b) => {
        return a.status.length - b.status.length;
      },
      filters: statusFilter,
      defaultFilteredValue: ['pending'],
      defaultSortOrder: 'ascend',
      onFilter: (value, record) => record.status === value,
      render: (text) => <Tag color={getColorByStatus(text)}>{text}</Tag>,
    },
    {
      title: 'Hour Rate',
      dataIndex: 'rate',
      rowKey: 'rate',
      render: (text) => <span>£ {text}</span>,
      sorter: (a, b) => {
        return a.rate - b.rate;
      },
    },
  ];

  const onlyCancelled =
    bookings.filter(({ status }) => status !== 'cancelled') < 1;

  if (!onlyCancelled) {
    columns.push({
      title: 'Actions',
      key: 'action',
      render: actions,
    });
  }
  return <Table dataSource={bookings} columns={columns} />;
};

BookingsTable.propTypes = {
  userKey: PropTypes.string.isRequired,
  profile: PropTypes.string.isRequired,
  bookings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  actions: PropTypes.func.isRequired,
};

BookingsTable.defaultTypes = {};

export default BookingsTable;
